// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__EupJE","modalBody":"ConfirmationPop_modalBody__iPdIk"};